import { REDUCER } from '../reducers/reducersConst';

/**
 * SECTION ACTIONS
 */

/**
 * Guardar las secciones de un usuario
 * @returns {{type: string}}
 */
export let setMyClassroomsSection = () => {
  return {
    type: REDUCER.SECTION.SET_MY_CLASSES
  };
};

/**
 * Guardar sección por defecto
 * @returns {{type: string}}
 */
export let setDefault = () => {
  return {
    type: REDUCER.SECTION.SET_DEFAULT
  };
};

/**
 * Indica si se debe mostrar el perfil
 * @param inProfile
 * @returns {{type: bool, inClassroom: *}}
 */
export let setInProfile = (inProfile = false) => {
  return {
    type: REDUCER.ROUTE.SET_IN_PROFILE,
    inProfile
  };
};
